export default {
    PUBLIC_KEY: "QbNwoNByYuijuWlWj",
    SERVICE_ID: "service_b5q9u25",
    TEMPLATE_ID: "template_xjmwoha"
}